import { ShiftSessionDetailPage } from "@/features/user-shift/pages/ShiftSessionDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/user-shift/$id/detail")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["shift_session.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ShiftSessionDetailPage,
});
